import { useEffect, useRef } from "react";
import { getUser } from "../utils";
import { updateLastOnline } from "../utils/Network";

const THROTTLE_MS = 5 * 60 * 1000; // ping at most once every 5 minutes
const ACTIVITY_EVENTS = ["click", "keydown", "scroll", "mousemove"];

/**
 * Frontend middleware: tracks CMS user activity and keeps `last_online`
 * up to date on the backend. Throttled so it never fires more than once
 * per THROTTLE_MS regardless of how many events occur.
 */
export default function useOnlineTracker() {
  const lastPingRef = useRef(0);

  const ping = () => {
    const now = Date.now();
    if (now - lastPingRef.current < THROTTLE_MS) return;

    const user = getUser();
    if (!user?.id) return;

    lastPingRef.current = now;
    updateLastOnline(user.id).catch(() => {});
  };

  useEffect(() => {
    ping();

    ACTIVITY_EVENTS.forEach((evt) =>
      window.addEventListener(evt, ping, { passive: true })
    );

    return () => {
      ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, ping));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
